import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context";
import { tableData } from "./tableData";
import { getActivityLogs } from "./handlers";
import { Container, MuniSpinner2, ScreenHeader, Table, Modal } from "../../components";

const ActivityLogs = () => {
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [logs, setLogs] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [row, setRow] = useState(false);

  useEffect(() => {
    if (!ua.hasRole("admin")) {
      navigate("/");
    } else {
      getActivityLogs(setLogs, setIsLoading);
    }
  }, []);

  return (
    <Container>
      <ScreenHeader screenHeaderTitle="Actividad" />
      {isLoading ? (
        <MuniSpinner2 />
      ) : (
        <>
          {logs && logs.length > 0 ? (
            <>
              {/* <p>Filtros</p> */}
              <Table data={tableData(logs, setShowModal, setRow)} name="logs" search />

              {row && showModal && (
                <Modal
                  show={showModal}
                  setShow={() => setShowModal(false)}
                  title={() => "Modificaciones"}
                >
                  {row && row.properties && (
                    <div className="p-2 rounded-2 env-box row">
                      <pre>
                        <code className="language-plaintext">
                          <span className="h5 text-primary">Valor anterior</span>
                          {Object.entries(JSON.parse(row.properties).old).map((envVar, i) => {
                            return (
                              <p key={i}>
                                <span className="var-name">{envVar[0]}=</span>
                                <span className="var-content text-wrap">{envVar[1]}</span>
                              </p>
                            );
                          })}
                        </code>
                      </pre>
                    </div>
                  )}
                  {row && row.properties && (
                    <div className="p-2 rounded-2 env-box row">
                      <pre>
                        <code className="language-plaintext">
                          <span className="h5 text-primary">Valor actual</span>
                          {Object.entries(JSON.parse(row.properties).attributes).map(
                            (envVar, i) => {
                              return (
                                <p key={i}>
                                  <span className="var-name">{envVar[0]}=</span>
                                  <span className="var-content text-wrap">{envVar[1]}</span>
                                </p>
                              );
                            }
                          )}
                        </code>
                      </pre>
                    </div>
                  )}
                </Modal>
              )}
            </>
          ) : (
            <p>Sin datos para mostrar.</p>
          )}
        </>
      )}
    </Container>
  );
};

export default ActivityLogs;
